import React from "react";
import { Modal } from "react-bootstrap";
import {RxCross2} from 'react-icons/rx'

const CommonModel = ({
  show,
  onHide,
  istabby = false,
  style = {},
  ...props
}) => {
  return (
    <Modal show={show} onHide={onHide} centered size="lg" fullscreen="md-down">
      <Modal.Body>
        {istabby ? (
          <div className="tabby-cross-button">
            <button
              className="close-button"
              onClick={() => {
                onHide();
              }}
            >
              <RxCross2/>
            </button>
          </div>
        ) : null}
        {props.children}
      </Modal.Body>
    </Modal>
  );
};

export default CommonModel;
